// Lead-identity contamination fix (2026-10-12): a follow-up draft must never be restorable
// into a different lead's form. Keying purely by `mode` let one lead's stale, never-submitted
// draft silently overwrite a different lead's fields on next mount (see the Sanjeev Kumar /
// Caio Li Bittencourt and Syed Tabish Hasan production rows this was traced to). For 'new'
// mode there is no parent to scope by, so it keeps the original unscoped key.
export function getDraftStorageKey(mode: 'new' | 'followup', parentResponseId?: string): string {
  if (mode === 'followup' && parentResponseId) {
    return `csr_lead_response_draft_followup_${parentResponseId}`;
  }
  return `csr_lead_response_draft_${mode}`;
}

// The pre-fix key every follow-up draft used to be saved under, regardless of which lead it
// belonged to. Never read from this key for restoration -- only used to proactively clear it
// so no legacy cross-lead draft can be restored by this or any other code path.
export const LEGACY_UNSCOPED_FOLLOWUP_DRAFT_KEY = 'csr_lead_response_draft_followup';
